import React from 'react'
import { Layout } from 'antd'

export default () => (
  <Layout.Footer className="center">
    &copy; 2018-2020 Raffskie
  </Layout.Footer>
)
